<!-- components/AFallbackImg.vue -->
<template>
  <img
      :src="currentSrc"
      :srcset="srcset"
      :sizes="sizes"
      :alt="alt"
      @load="onLoad"
      @error="onError"
      referrerpolicy="no-referrer"
      :class="['transition-opacity duration-300', loaded ? 'opacity-100' : 'opacity-0']"
    />
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  src: { type: String, required: true },
  fallback: { type: String, required: true },
  alt: { type: String, default: '' },
  srcset: { type: String, default: '' },
  sizes: { type: String, default: '' },
  retryCount: { type: Number, default: 1 },
  retryDelayMs: { type: Number, default: 400 },
})

const emit = defineEmits(['load', 'error', 'fallback'])

const attempt = ref(0)
const usingFallback = ref(false)
const currentSrc = ref(props.src || '')
const loaded = ref(false)

watch(() => props.src, (v) => {
  attempt.value = 0
  usingFallback.value = false
  loaded.value = false
  currentSrc.value = v || ''
})

function onLoad() {
  loaded.value = true
  emit('load', { src: currentSrc.value })
}

function onError() {
  emit('error', { src: currentSrc.value })

  if (usingFallback.value) return

  if (attempt.value < props.retryCount) {
    attempt.value += 1
    setTimeout(() => {
      // ensure we call includes on a string even if currentSrc is falsy
      const hasQuery = (currentSrc.value || '').includes('?')
      const cacheBust = hasQuery ? '&' : '?'
      currentSrc.value = `${props.src}${cacheBust}r=${Date.now()}`
    }, props.retryDelayMs)
    return
  }

  usingFallback.value = true
  currentSrc.value = props.fallback
  emit('fallback', { src: props.fallback })
}
</script>
